import React, { ChangeEvent } from 'react'
import clsx from 'clsx'
import useStyles from './RadioButton.styles'

interface Props {
  id: string
  label: string
  className?: string
  name?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

const RadioButton = React.forwardRef<HTMLInputElement, Props>(
  ({ id, label, className, name, onChange, onBlur, disabled = false }, ref) => {
    const classes = useStyles()

    return (
      <div className={clsx(classes.root, className, { [classes.disabled]: disabled })}>
        <input
          className="radioInput"
          name={name}
          id={id}
          type="radio"
          value={id}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
          disabled={disabled}
          ref={ref}
        />

        <label htmlFor={id} className={classes.radioLabel}>
          {label}
        </label>
      </div>
    )
  }
)

export default RadioButton
